import React, { useState, useEffect } from "react";
import styles from "../OnlineShop/OnlineShop.module.css";
import onlineShop from "../../assets/images/onlineShop.jpg";
import ShopItemSection from "./ShopItemSection";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import cart_icon from "../../assets/images/icons/shopping_cart_icon.png";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Link, animateScroll as scroll } from "react-scroll";
import queryString from "query-string";
const OnlineShop = ({ locked = false }) => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const [categoryRows, setCategoryRows] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const params = queryString.parse(location.search);
  const id = params.id;

  // Fetches data from server when mounted
  useEffect(() => {
    const authToken = JSON.parse(localStorage.getItem("authTokens"));
    axios
      .get(backend_base + "/shop/product", {
        headers: {
          Authorization: authToken ? "Bearer " + authToken?.access : "",
        },
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          let tempCategoryRows = [];
          const allShopCategories = res.data.categories;
          for (let i = 0; i < allShopCategories.length; i += 4) {
            tempCategoryRows.push(allShopCategories.slice(i, i + 4));
          }
          console.log("res.data.products");
          console.log(res.data.products);
          setCategoryRows(tempCategoryRows);
          setAllProducts(res.data.products);
          scrollToProduct();
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const [itemAddedPopup, setItemAddedPopup] = useState(false);
  const [cartChanged, setCartChanged] = useState(false);

  const alterCartChanged = () => {
    setCartChanged(!cartChanged);
  };

  const scrollToProduct = () => {
    setTimeout(() => {
      if (allProducts) {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 500);
  };

  return (
    <>
      <Header cartChanged={cartChanged} />
      <div
        style={{ display: itemAddedPopup ? "" : "none" }}
        className={styles.iap_main_div}
      >
        <div className={styles.iap_main_sec}>
          <div
            onClick={() => {
              setItemAddedPopup(false);
            }}
            className={styles.iap_icon_main}
          >
            <ion-icon className={styles.cross_icon} name="close"></ion-icon>
          </div>
          <div className={styles.iap_top_heading}>
            <div className={styles.iap_heading1}>
              <img
                className={styles.iap_cart_icon}
                src={cart_icon}
                alt="cart"
              />
              Add to cart
            </div>
            <div className={styles.iap_heading2}>アイテムを追加しました。</div>
          </div>
          <div className={styles.iap_button_main}>
            <div
              onClick={() => {
                setItemAddedPopup(false);
              }}
              className={styles.iap_button1}
            >
              お買い物を続ける
            </div>
            <div
              onClick={() => {
                navigate("/cart");
              }}
              className={styles.iap_button2}
            >
              カートへ進む
            </div>
          </div>
        </div>
      </div>
      <div className={styles.online_shop}>
        <div className={styles.online_shop_banner}>
          <img src={onlineShop} alt="online shop" />
          <div className={styles.online_shop_banner_text}>Item goods</div>
        </div>
        {/* online shop tags start*/}
        <div
          className={`${styles.online_shop_all_tags_section}
        justify-content-center 
        container`}
        >
          {Array.isArray(categoryRows) &&
            categoryRows.length > 0 &&
            categoryRows.map((row, index) => {
              return (
                <div
                  key={index}
                  className={styles.online_shop_tag_row + "row  "}
                >
                  {row.map((item, index) => {
                    return (
                      <Link
                        key={index}
                        activeClass="active"
                        to={item}
                        spy={true}
                        smooth={true}
                        offset={-140}
                        duration={500}
                      >
                        <div
                          className={`${styles.tag_div} col-3 badge badge-pill`}
                        >
                          <div className={styles.tag_heading}>{item}</div>
                        </div>
                      </Link>
                    );
                  })}
                  <div className={styles.online_shop_tag_row_space}></div>
                </div>
              );
            })}
        </div>
        {/* <hr className={styles.tag_underLine} /> */}
        {Array.isArray(allProducts) &&
          allProducts.length > 0 &&
          allProducts.map((item, index) => {
            return (
              <div id={item?.category_name}>
                <ShopItemSection
                  id={index}
                  locked={locked}
                  key={index}
                  detail={item}
                  open_popup={setItemAddedPopup}
                  setCartChanged={alterCartChanged}
                />
              </div>
            );
          })}
        <div className={styles.main_margin_bottom}></div>
      </div>
      <Footer />
    </>
  );
};

export default OnlineShop;
